import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import {
  login,
  register,
  UserSession
} from '../utils'
import { Client, Account, OAuthProvider } from 'appwrite'
import logo from "../assets/tom-logo-icon-black.jpg"
import { AppProvider } from '@toolpad/core/AppProvider';
import { SignInPage } from '@toolpad/core/SignInPage';
import { useTheme, createTheme } from '@mui/material/styles';
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Link,
  IconButton,
  Button,
  Stack,
  Typography
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';


const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID)

const account = new Account(client)


const providers = [{ id: 'google', name: 'Google' }, { id: 'credentials', name: 'Credentials' }];

const authLogin = async(provider) => {
  account.createOAuth2Session(
    OAuthProvider[provider],
    'http://localhost:5173',
    'http://localhost:5173'
  );
}

const BRANDING = {
  logo: (
    <img
      src={logo}
      alt="Takeoff Monkey Widgets Logo"
      style={{ height: 48 }}
    />
  ),
  title: 'Takeoff Monkey Widgets',
};

function CustomPasswordField() {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel
        htmlFor="outlined-adornment-password"
        sx={{
          mt: 1.5,
          alignItems: 'center',
          display: 'flex',
          height: 0,
          overflow: 'visible',
          fontSize: '1em'
        }}
      >
        Password
      </InputLabel>
      <OutlinedInput
        id="outlined-adornment-password"
        type={showPassword ? 'text' : 'password'}
        name="password"
        label="Password"
        sx={{ height: '2.5em', overflow: 'hidden' }}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
              size="small"
            >
              {showPassword ? (
                <VisibilityOff fontSize="inherit" />
              ) : (
                <Visibility fontSize="inherit" />
              )}
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
}

function ForgotPasswordLink() {
  const navigate = useNavigate()

  return (
    <Link
      variant="body2"
      onClick={() => navigate('/reset-password')}
      sx={{
        position: 'relative',
        display: 'flex',
        my: 'auto',
        height: '2.5em',
        width: 'fit-content',
        alignItems: 'center',
        cursor: 'pointer'
      }}
    >
      Forgot password?
    </Link>
  );
}


export default function Login() {
  const navigate = useNavigate()
  const [session, setSession] = useAtom(UserSession)

  useEffect(() => {
      const checkSession = async () => {
        try {
            const user = await account.get()
            if (user) {
              navigate('/')
            }
        } catch (error) {}
    }
  }, [])
  
  const handleLogin = async (provider, formData, callbackUrl) => {
    console.log("Logging in with provider:", provider.name);
    if (provider && provider.name !== 'Credentials') {
      authLogin(provider.name)
    } else {
      const email = formData.get('email');
      const password = formData.get('password');

      try {
        const user = await account.createEmailPasswordSession(email, password).then(() => {
          return account.get()
        })
        setSession(user);

        console.log("User logged in:", user);
        navigate(callbackUrl || '/');
      } catch (error) {
        console.error(error);
        alert("Sign-in error: " + error.message);
      }
    }
  }

  const theme = createTheme({
    palette: {
      mode: 'dark',
    },
  });

  return (
    <AppProvider branding={BRANDING} theme={theme}>
      <Stack direction="row" sx={{ maxWidth: '500px', mx: 'auto' }}>
        <Button
          variant="text"
          onClick={() => navigate('/')}
          sx={{
            position: 'relative',
            display: 'flex',
            my: 'auto',
            height: '2.5em',
            width: 'fit-content',
            alignItems: 'center'
          }}
        >
          <ArrowBackIosNewOutlinedIcon sx={{ mr: '0.5em', fontSize: '1em' }} />
          Back&nbsp;
        </Button>
        <SignInPage
          signIn={handleLogin}
          providers={providers}
          slotProps={{
            emailField: {
              sx: { '& .MuiInputBase-root': { height: '2.5em', overflow: 'hidden' } },
            },
            passwordField: {
              sx: { '& .MuiInputBase-root': { height: '2.5em', overflow: 'hidden' } },
            }
          }}
          slots={{
            title: () => <Typography variant="h4" sx={{ mt: 1, mb: 2 }}>Log in</Typography>,
            subtitle: () => null,
            passwordField: CustomPasswordField,
            forgotPasswordLink: ForgotPasswordLink,
            rememberMe: () => null,
            // submitButton: () => <Button variant="contained" fullWidth size="large" sx={{ mt: 2 }}>Login</Button>
          }}
        />
      </Stack>
    </AppProvider>
  );
}